// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3RbII","log":"ModalInventoryLogs_log__3sEhg","date":"ModalInventoryLogs_date__q4pRe","userName":"ModalInventoryLogs_userName__2W5g2"};